import { createBrowserRouter } from 'react-router-dom'
import { StoreSelectionScreen } from '@/features/Pickup/StoreSelectionScreen'
import { AddressSearchScreen } from '@/features/AddressSearchScreen/AddressSearchScreen'
import { ConfirmLocationScreen } from '@/features/AddressSearchScreen/ConfirmLocationScreen'
import { DeliveryResultsScreen } from '@/features/StoreAvailableForDelivery/DeliveryResultsScreen'
import { MapViewScreen } from '@/features/StoreMapView/MapViewScreen'
import { LoginPage } from '@/features/Authentication/components/LoginPage'
import App from './App'

export const router = createBrowserRouter([
  {
    
    Component: App,
    children: [
      {
        index: true,
        Component: StoreSelectionScreen,
      },
      {
        path: 'address-search',
        Component: AddressSearchScreen,
      },
      {
        path: 'confirm-location',
        Component: ConfirmLocationScreen,
      },
      {
        path: 'delivery-results',
        Component: DeliveryResultsScreen,
      },
      {
        path: 'map',
        Component: MapViewScreen,
      },
      {
        path: 'login',
        Component: LoginPage,
      },
    ],
  },
])
